import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const WaiveCompliancePenalChargeModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  waivePenalCharge, waivePenalChargeError, onWaivePenalChargeChange,
  booleanList
}) =>
  <ModalFormUI
    context={context}
    titleLabel=''
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF name='waivePenalCharge' value={waivePenalCharge} required={true}
      label='Waive penal charge' optionList={booleanList}
      onChange={onWaivePenalChargeChange} error={waivePenalChargeError}
    />
  </ModalFormUI>

export default WaiveCompliancePenalChargeModalUI
